import Vue from 'vue'
import { Button } from 'view-design';
export const getBrowserVersion = () => {
    var inBrowser = typeof window !== 'undefined';
    var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
    var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
    var UA = inBrowser && window.navigator.userAgent.toLowerCase();
    var isIE = UA && /msie|trident/.test(UA);
    var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
    var isEdge = UA && UA.indexOf('edge/') > 0;
    var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
    var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
    var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
    var isPhantomJS = UA && /phantomjs/.test(UA);
    var isFF = UA && UA.match(/firefox\/(\d+)/);

    var all = {
        isIE: isIE,
        isIE9: isIE9,
        isEdge: isEdge,
        isAndroid: isAndroid,
        isIOS: isIOS,
        isChrome: isChrome,
        isPhantomJS: isPhantomJS,
        isFF: isFF,
    }
    return all
}

export const getSMSFrom = () => {
    let type = {}
    type.SMS_CODE_TYPE_REG = 1 //注册时获取验证码
    type.SMS_CODE_TYPE_MOBILE_LOGIN = 2 //登录时获取验证码
    type.SMS_CODE_TYPE_UPDATE_PWD = 3 //更新时获取验证码
    type.SMS_CODE_TYPE_ACTIVE_ACCOUNT = 4 //登陆时激活账号获取验证码
    type.SMS_CODE_TYPE_WX_EDIT_ACCOUNT = 5 //微信登录后修改账号获取验证码
    type.SMS_CODE_TYPE_BIND_MOBILE=6       //团购用户登录后绑定手机号码下发短信验证码
    type.SMS_CODE_TYPE_EDIT_ACCOUNT = 7    //购买成功后可以有一次修改账号的机会
    type.SMS_CODE_TYPE_RESET_WXTOKEN = 8    //解除现有的微信绑定关系
    type.SMS_CODE_TYPE_VOLID_OLDPHONE = 40001 //验证旧手机获取验证码
    type.SMS_CODE_TYPE_VOLID_NEWPHONE = 40002 //验证新手机获取验证码
    return type
}

export const getPayState = () => {
    let type = {}
    type.PAYSTATUS_WAITINGPAY = 0 //等待支付
    type.PAYSTATUS_TIMEOUT = -200 //支付超时
    type.PAYSTATUS_PAYEND = 100 //支付完成
    type.PAYSTATUS_CANCELLED = -99 //支付取消
    return type
}

export const getWxState = () => {
    let type = {}
    type.WXREG = 1 //微信注册
    type.WXLOGIN = 2 //微信登录
    type.WXBIND = 3 //微信绑定
    return type
}

export const getQRStatus=()=>{
    let type = {}
    type.IDENTITYSTATUS_INIT  = 0 //等待微信扫码
    type.IDENTITYSTATUS_WAITING  = 20 // 等待微信授权
    type.IDENTITYSTATUS_APPROVE  = 21 // 微信已同意授权
    type.IDENTITYSTATUS_CANCEL  = -22 // 微信已取消授权
    type.IDENTITYSTATUS_INVALIDATION = -99 //二维码失效
    return type
}

export const getRenewType=()=>{
    let type = {}
    type.PURCHASE  = 1 //购买
    type.RENEWAL  = 2  //续费
    type.UPDATE  = 3  //升级
    return type
}

export const getPermission = () => {
    let permission = {}
    permission.CODE_FUNC_LOCALVERSION = "000001" // 地方版
    permission.CODE_FUNC_CLOUD = "000002" // 智慧云端
    permission.CODE_FUNC_SECRETARY = "000003" // 我的秘书getPermission
    permission.CODE_FUNC_SEARCH_REDUCTION = "000004" // 税收优惠检索
    permission.CODE_FUNC_SEARCH_TREATY = "000005" // 条约检索
    permission.CODE_FUNC_SEARCH_INDUSTRY = "000006" // 行业检索
    permission.CODE_FUNC_SEARCH_INOUT = "000007" // 进出口税收检索
    permission.CODE_FUNC_WEB_MOBILE = "000008" // 移动云擎
    permission.CODE_FUNC_UPLOAD = "000009" // 一键上传
    permission.CODE_FUNC_DOWNLOAD = "000010" // 云擎下载
    permission.CODE_FUNC_SCREEN = "000011" // 分屏浏览
    permission.CODE_FUNC_FOLDER = "000012" // 文件夹
    permission.CODE_FUNC_CHECKUPLOAD = "000013" // 选择性上传
    permission.CODE_FUNC_ONEDOWNLOAD = "000014" // 普通下载
    permission.CODE_FUNC_CENTRALVERSION = "000015" // 全国版
    permission.CODE_FUNC_SEARCH_ALL = "000016" // 综合检索
    return permission
}
//1=通用，2=专属，3=最新文件，4=效力变动,5=优惠项目，6=优惠税种
export const pushScene = () =>{
    let scene={}
    scene.COMMON=1
    scene.SPECIAL=2
    scene.TAX_ITEM=3
    scene.TAX_CATEGORIES=4
    scene.NEW_DOC=5
    scene.POTENCE=6
    return scene
}
//1=項目 2=行业 3=优惠
export const queryType=()=>{
    let query={}
    query.COMMON=1
    query.SPECIAL=2
    query.TAX_ITEM=3
    query.TAX_CATEGORIES=4
    return query
}

export const fileMatchScene = () =>{
    let scene={}
    scene.COMMON=1
    scene.SPECIAL=2
    scene.TAX_ITEM=3
    return scene
}

export const showModal = () => {
    console.log('modal=============================>')
    let modal_bg = document.createElement("div");
    //let _modal = document.createElement("Modal");
    let p = document.createElement("p");
    p.innerHTML = "提示1111"
    //_modal.setAttribute("width", "450");
    //_modal.setAttribute("v-model", "true");
    //_modal.appendChild(p)
    modal_bg.appendChild(p)
    console.log(modal_bg)
    document.body.appendChild(modal_bg);
}

export const showMask = () => {
    var mask = document.createElement('div');
    mask.style.width = window.innerWidth + 'px';
    mask.style.height = window.innerHeight + 'px';
    mask.style.background = '#000';
    mask.style.opacity = '.5';
    mask.style.position = 'absolute';
    mask.style.top = '0';
    mask.style.left = '0';
    mask.style.zIndex = 10086;

    let button = document.createElement('div');
    button.innerHTML = "重新登录"
    button.style.width = '150px';
    button.style.height = '30px';
    button.style.backgroundColor = '#2d8cf0';
    button.style.color = 'white';
    button.style.fontSize = '14px;';
    button.style.lineHeight = "30px"
    button.style.verticalAlign = "middle"
    button.style.cursor = "pointer"
    button.style.zIndex = 10087;

    // button.style.borderWidth = "1px"
    // button.style.borderStyle = "solid"
    // button.style.borderColor = "white"
    button.style.textAlign = "center"
    button.style.position = "relative"
    button.style.left = "50%"
    button.style.top = "45%"
    button.onclick = function() {
        window.location.reload()
    }

    mask.appendChild(button)
    document.body.appendChild(mask);
}

/* 是否邮箱*/
export function isEmail(value) {
    const reg = /[^@]\@/g;
    if (value == '' || value == undefined || value == null) {
        return false
    } else {
        if (!reg.test(value)) {
            return false
        } else {
            return true
        }
    }
}
//邮箱，可为空
export function isEmptyOrEmail(value) {
    const reg = /[^@]\@/g;
    if(value===''){
        return true
    }

    if (!reg.test(value)) {
        return false
    } else {
        return true
    }
}

//手机，可为空
export function isEmptyOrmobile(value) {

}

export const getUrlBase64 = (url, callback) => {
    // let ext = "png"
    // var canvas = document.createElement("canvas"); //创建canvas DOM元素
    // var ctx = canvas.getContext("2d");
    // var img = new Image;
    // img.crossOrigin = 'Anonymous';
    // img.src = url;
    // img.onload = function() {
    //     canvas.height = 1042; //指定画板的高度,自定义
    //     canvas.width = 1012; //指定画板的宽度，自定义
    //     ctx.drawImage(img, 0, 0, 1042, 1012); //参数可自定义
    //     var dataURL = canvas.toDataURL("image/");
    //     callback.call(this, dataURL); //回掉函数获取Base64编码
    //     canvas = null;
    // };
}
//最大支持万亿，即13位数。如果需要更高位的，可以直接在 baseArray 变量里添加进位填充字符即可。
export const numberToChineseString = (number) => {
    if(number.match(/\D/) || number.length >= 14) return;
    let zhArray = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']; // 数字对应中文
    let baseArray = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万']; //进位填充字符，第一位是 个位，可省略
    let string = String(number).split('').reverse().map((item, index) => { // 把数字切割成数组并倒序排列，然后进行遍历转成中文
        // 如果当前位为0，直接输出数字， 否则输出 数字 + 进位填充字符
        item = Number(item) == 0 ? zhArray[Number(item)] : zhArray[Number(item)] + baseArray[index];
        return item;
    }).reverse().join(''); // 倒叙回来数组，拼接成字符串
    string = string.replace(/^一十/, '十');  // 如果以 一十 开头，可省略一
    string = string.replace(/零+/, '零');  // 如果有多位相邻的零，只写一个即可
    return string;
}


const ss4=function(){
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
}
export const strGuid = () =>{
    return  ss4() + ss4() + '-' + ss4() + '-' + ss4() + '-' +
           ss4() + '-' + ss4() + ss4() + ss4();
}


export const getFileClass = () => {
    let fileclass = {}
    fileclass.SPECIFIC_APPLICABLE_OBJECTS = "000001"  // 特定适用对象
    fileclass.TAX_INCENTIVES  = "000002"              // 税收优惠
    fileclass.TAX_CONVENTION = "000007"          // 税收条约
    return fileclass
}